export default {
  label: {
    greeting: 'Hello',
    login: 'Sign in',
    item: {
      config: 'Settings',
      createComponent: 'Create component',
      exit: 'Sign out',
    },
  },
};
